import styles from './mainView.module.scss'

import AppContext from '../../../context/AppContext'
import React from 'react'
import Popup from '../../popup/Popup'

const levels = [
  { icon: 'new', text: 'New', level: 1 },
  { icon: 'beginner', text: 'Beginner', level: 2 },
  { icon: 'intermediate', text: 'Intermediate', level: 3 },
  { icon: 'advanced', text: 'Advanced', level: 5 },
]

export default class MainView extends React.Component {
  static backgroundTransparent = true

  static contextType = AppContext

  constructor(props) {
    super(props)

    this.state = {
      level: 1,
      visible: true,
    }
  }

  _start() {
    this.props.switchView.game({
      level: this.state.level,
    })
  }

  _chooseLevel(level) {
    this.setState({ level: level })
  }

  render() {
    return this.state.visible ? (
      <Popup
        className="level"
        size="wide"
        title="Play Online Checkers"
        subtitle={`What is your skill level in ${this.props.rules.name}?`}
        closable={true}
        onClose={(dismissed) => (dismissed ? this.context.app.exit() : null)}
        buttons={[{ text: 'Play', handler: () => this._start() }]}
      >
        <div className={styles.wrapper}>
          <ul className={styles.list}>
            {levels.map((level, index) => (
              <li
                className={styles.item}
                key={index}
                onClick={() => this._chooseLevel(level.level)}
              >
                <button
                  className={`${styles.button} ${styles[level.icon]} ${
                    this.state.level === level.level ? styles.checked : ''
                  }`}
                  onClick={() => this._chooseLevel(level.level)}
                >
                  {level.text}
                </button>
              </li>
            ))}
          </ul>
        </div>
      </Popup>
    ) : null
  }
}
